import { Text, type TextProps } from "@mantine/core";
import { formatMoney } from "../../utils/format";

/** Renders a billing amount with thousands separators, currency, and
 *  tabular-nums alignment (so columns of figures line up). */
export function Money({
  value,
  currency,
  ...props
}: { value: string | number | null | undefined; currency?: string } & TextProps) {
  return (
    <Text component="span" style={{ fontVariantNumeric: "tabular-nums" }} {...props}>
      {formatMoney(value, currency)}
    </Text>
  );
}
